import { type Interpolation, type Theme } from '@emotion/react'
import { mdiClose, mdiCloseCircle } from '@mdi/js'
import Icon from '@mdi/react'
import { memo } from 'react'
import IconButton from './IconButton'

interface IButtonX {
    onClick(event?: any): void
    overrides?: Interpolation<Theme>
    clearInputIcon?: string
    clearInputIconColor?: string
    title?: string
    size?: number
}

const ButtonX = ({
    onClick,
    overrides,
    clearInputIcon,
    clearInputIconColor,
    title,
    size = 0.75,
}: IButtonX) => {
    return (
        <IconButton
            data-testid="IconButton_X"
            onClick={onClick}
            css={overrides}
            title={title}
        >
            <Icon
                path={
                    clearInputIcon === 'closeCircle' ? mdiCloseCircle : mdiClose
                }
                color={clearInputIconColor}
                size={size}
            />
        </IconButton>
    )
}

export default memo(ButtonX)
